import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from 'styled-components';
import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { isEmpty, get } from "lodash";
import loanStatuses from "constants/loanStatuses";
import { addLoan, getLoanById, clearLoan, clearLoanCount, clearEditLoan } from "store/state/loan/loan";
import { getDealName } from "store/state/deal";
import LoanAttachments from "components/Global/OptionsMenu/LoanTable/LoanAttachments";
import LoanNotes from "components/Global/OptionsMenu/LoanTable/LoanNotes";
import SimpleInfoDialog from 'components/Global/ConfirmationDialogs/SimpleInfoDialog';
import { setEnumeratedTypesListState } from "./util";
import { getLenders, getloanStatuses } from "store/state/enumeratedTypes";
import LoanTerms from "./Sections/LoanTerms";
import LenderPassed from "./Sections/LenderPassed";
import Recourse from "./Sections/Recourse";
import Fees from "./Sections/Fees";
import Reserves from "./Sections/Reserves";
import Hedge from "./Sections/Hedge";
import Covenants from "./Sections/Covenants";
import Other from './Sections/Other';
import LoanNavigation from "./LoanNavigation";
import Styles from "./styles";
import { updateLoanStatusById } from "store/state/loan/loan";
import LoanHeader from "./LoanHeader";
import SimpleConfirmDialog from "components/Global/ConfirmationDialogs/SimpleConfirmDialog";
import QuoteDuplicationConfirmationDialog from "components/Global/ConfirmationDialogs/QuoteDuplicationConfirmationDialog";

import { ACCESS_TYPE_PIPELINE_DEAL } from "constants/accessTypes";
import { getGuestsByDealId } from 'store/state/guest';
import guestPermissionHelper from "utils/guestPermissionHelper"
import dealById from "selectors/deal";
import { fetchDeal } from "store/state/deal";

const styles = theme => ({

  marginalize:{
    marginLeft:"15px"
  },
  container:{
    paddingLeft:"17px"
  }

});
const BreadCrumbLink = styled(Link)`
font-size:17px;  
font-weight:bold;
`
const LastLink = styled.span`
font-size:17px;  
color: #606061;
font-weight:bold;
`
const FormSection = styled.div`
  position:relative;
`

class NewLoan extends React.Component {
  state = {
    loan: {},
    isNewLoan: true,
    isEditing: true,
    isInitialized: false,
    isValueAdd: false,
    selectedLoanStatusId: "",
    passReason: {},
    activeSectionId: 'loan_terms',
    isAttachmentsOpen: false,
    isNotesOpen: false,
    scrollTop: 0,
    elementScrollPositions: {},
    isValidationModalOpen: false,
    loanStatuses: [],
    refreshLoanStatuses: false,
    duplicateReady: true,
    guestPermissions: {isGuest: false},
  };
  constructor(props){
    super(props);
    this.formRef = React.createRef();
  }

  getOffset = (id) => {
    let el = document.getElementById(id)
    if(!el)
      return 0;    
    return el.offsetTop;
  }
  calculateAbsDist = (currentScrollTop, elementScrollTop) => {    
    let val =  currentScrollTop - (elementScrollTop);
    if(val < 0)
      return 999999; //TODO: find a better way to handle negative values than a magic number
    return val;
  }
  findActiveSectionId = (scrollTop) => {    
    const {elementScrollPositions,activeSectionId} = this.state;
    let minDistance = null;
    for(var key in elementScrollPositions){
      if(elementScrollPositions.hasOwnProperty(key)){                    
        let elementDistance = this.calculateAbsDist(scrollTop, elementScrollPositions[key]);        
        if(!minDistance)
          minDistance = { distance: elementDistance, sectionId: key}
        else if(elementDistance < minDistance.distance)
          minDistance = { distance: elementDistance, sectionId: key}
      }
    }                    
    if(minDistance == null)
      return activeSectionId;
    return minDistance.sectionId;
  }

  detectScroll = (e) => {
    const scrollTop = this.formRef.current.scrollTop;    
    const {activeSectionId} = this.state;    
    const nextActiveSectionId = this.findActiveSectionId(scrollTop);
    if(nextActiveSectionId && activeSectionId !== nextActiveSectionId){      
      this.setState({
        activeSectionId: nextActiveSectionId
      });
    }
  }
  selectSection = (sectionId) => {    
    const section = document.getElementById(sectionId);    
    if (section) {      
      section.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }    
  }
  openNotes = () => {
    if (!this.state.loan.id) this.save();
    this.setState({ isNotesOpen: true });
  };

  closeNotes = () => {
    this.setState({ isNotesOpen: false });
  };

  openAttachments = () => {
    if (!this.state.loan.id) this.save();
    this.setState({ isAttachmentsOpen: true });
  };

  closeAttachments = () => {
    this.setState({ isAttachmentsOpen: false });
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.location && nextProps.location && this.props.location.pathname !== nextProps.location.pathname) {
      window.location.reload();
    }
  }
  
  componentDidMount() {
    this.props.clearLoan();
    const { loanId, dealId, isEditingParam } = this.props;
    this.props.getloanStatuses();
    this.props.getLenders();
    this.props.getDealName({ dealId: dealId, subKey: dealId });
    if (loanId) {
      this.props.getLoanById({ loanId });
    } else {
      this.setState({ loan: {loanStatusId: loanStatuses.QUOTE} });
    }
    this.setState({isEditing: isEditingParam});
    this.props.getGuestsByDealId({ dealId: dealId, accessTypeId: ACCESS_TYPE_PIPELINE_DEAL  })
  }

  componentDidUpdate(prevProps, prevState) {
    this.setFormInitialState(this.props, prevProps, prevState);
    const {loan, isEditing} = this.state;
    const {loan:prevLoan, isEditing: prevIsEditing} = prevState;
    if(loan !== prevLoan || isEditing !== prevIsEditing){
      setTimeout(() => {
        this.setState({
          elementScrollPositions: {
          loan_terms: this.getOffset('loan_terms'),
          loan_recourse: this.getOffset('loan_recourse'),
          loan_fees: this.getOffset('loan_fees'),
          loan_reserves: this.getOffset('loan_reserves'),
          loan_hedge: this.getOffset('loan_hedge'),        
          loan_covenants: this.getOffset('loan_covenants'),        
          loan_other: this.getOffset('loan_other')
          }
        })   
      });   
    }    
    this.setLoanStatusOptionsBasedOnSavedLoanStatus();
    if(prevProps.clone != this.props.clone){
      this.setState({isCloneDialogOpen:true});
    }
    this.updateGuestState();
  }

  updateGuestState(){
    const shouldBuildGuestPermissions = guestPermissionHelper.shouldBuildGuestPermissions(this.props.authentication.guestAccess,
                                                                                          this.props.deal,
                                                                                          this.props.guestPermission,
                                                                                          this.props.dealguests);

    if(shouldBuildGuestPermissions && !this.state.guestPermissions.isGuest){
      const guestPermissions = guestPermissionHelper.buildGuestPermissions(this.props.authentication.guestAccess,
                                                                            this.props.deal,
                                                                            this.props.guestPermission,
                                                                            this.props.dealguests,
                                                                            "pipelinePermission",
                                                                                          this.props.history);
      this.setState({guestPermissions: guestPermissions});
    }
  }

 closeCloneDialog = () => {
   this.setState({isCloneDialogOpen:false, duplicateReady:true});
 } 

setLoanStatusOptionsBasedOnSavedLoanStatus(){
  const {loan} = this.state;
  if(loan && loan.loanStatusId){
    let statusesToExclude = [];
    
    switch (loan.loanStatusId) {
      case loanStatuses.QUOTE:
        statusesToExclude.push(loanStatuses.CLOSED_LOAN);
        statusesToExclude.push(loanStatuses.IN_CLOSING);
        statusesToExclude.push(loanStatuses.PAID_OFF);
        statusesToExclude.push(loanStatuses.WINNING_QUOTE);
        break;
      case loanStatuses.REJECTED_QUOTE:
        statusesToExclude.push(loanStatuses.PASSED_QUOTE);
        statusesToExclude.push(loanStatuses.CLOSED_LOAN);
        statusesToExclude.push(loanStatuses.IN_CLOSING);
        statusesToExclude.push(loanStatuses.PAID_OFF);
        statusesToExclude.push(loanStatuses.WINNING_QUOTE);
        break;
      case loanStatuses.PASSED_QUOTE:
        statusesToExclude.push(loanStatuses.REJECTED_QUOTE);
        statusesToExclude.push(loanStatuses.CLOSED_LOAN);
        statusesToExclude.push(loanStatuses.IN_CLOSING);
        statusesToExclude.push(loanStatuses.PAID_OFF);
        statusesToExclude.push(loanStatuses.WINNING_QUOTE);
        break;
      case loanStatuses.CLOSED_LOAN:
        statusesToExclude.push(loanStatuses.QUOTE);
        statusesToExclude.push(loanStatuses.REJECTED_QUOTE);
        statusesToExclude.push(loanStatuses.PASSED_QUOTE);
        statusesToExclude.push(loanStatuses.IN_CLOSING);
        statusesToExclude.push(loanStatuses.PAID_OFF);
        statusesToExclude.push(loanStatuses.WINNING_QUOTE);
        break;
      case loanStatuses.IN_CLOSING:
        statusesToExclude.push(loanStatuses.QUOTE);
        statusesToExclude.push(loanStatuses.REJECTED_QUOTE);
        statusesToExclude.push(loanStatuses.PASSED_QUOTE);
        statusesToExclude.push(loanStatuses.PAID_OFF);
        statusesToExclude.push(loanStatuses.WINNING_QUOTE);
        break;
      case loanStatuses.PAID_OFF:
        statusesToExclude.push(loanStatuses.QUOTE);
        statusesToExclude.push(loanStatuses.REJECTED_QUOTE);
        statusesToExclude.push(loanStatuses.PASSED_QUOTE);
        statusesToExclude.push(loanStatuses.CLOSED_LOAN);
        statusesToExclude.push(loanStatuses.IN_CLOSING);
        statusesToExclude.push(loanStatuses.WINNING_QUOTE);
        break;
      case loanStatuses.WINNING_QUOTE:
        statusesToExclude.push(loanStatuses.QUOTE);
        statusesToExclude.push(loanStatuses.REJECTED_QUOTE);
        statusesToExclude.push(loanStatuses.PASSED_QUOTE);
        statusesToExclude.push(loanStatuses.CLOSED_LOAN);
        statusesToExclude.push(loanStatuses.IN_CLOSING);
        statusesToExclude.push(loanStatuses.PAID_OFF);
        break;
      default:
        break;
    }

    setEnumeratedTypesListState("loan_statuses", "loanStatuses", this, statusesToExclude, false, false, this.state.refreshLoanStatuses);
    if(this.state.refreshLoanStatuses)
      this.setState({refreshLoanStatuses: false });
    }
}

  setFormInitialState = (props, prevProps, prevState) => {
    const { loan, isNewLoan } = this.state;
    const { savedLoan, loanId, dealId } = this.props;
    if (savedLoan && savedLoan !== loan && isNewLoan) {
      this.setState({
        loan: savedLoan,
        isNewLoan: false,
        selectedLoanStatusId: savedLoan.loanStatusId,
        isInitialized: savedLoan.loanStatusId !== null
      });
    }
  };

  handleChange = (name, data) => {
    const val = data ? data.value : null;
    this.setState({
      loan: { ...this.state.loan, [name]: val }
    });    

    if (name === "loanStatusId") {
      this.handleLoanStatusSelected(val);
    } else if (name === "loanTypeId") {
      this.setState({
        isInitialized: val !== null && val !== loanStatuses.PASSED_QUOTE
      });
    }
  };

  handlePassReasonChange = (name, data) => {
    this.setState({
      passReason: { ...this.state.passReason, [name]: data ? data.value : null }
    });
  };

  handleLoanStatusSelected = loanStatusId => {
    this.setState({
      selectedLoanStatusId: loanStatusId
    });
  };

  handleBooleanChange = ({ target: { name, value } }) => {
    this.setState({
      loan: {
        ...this.state.loan,
        [name]: value === "true"
      }
    });
  };

  handleTextChange = ({ target: { name, value } }) => {
    this.setState({
      loan: {
        ...this.state.loan,
        [name]: value
      }
    });
  };

  cancel = () => {
    this.cancelEdit(this.state.isNewLoan);
  };

  cancelEdit = (shouldGoBack) => {
    this.props.clearLoan();    
    this.props.clearLoanCount({
      callback: () => {        
        if(shouldGoBack){          
          const { dealId } = this.props;
          this.props.history.push(`/pipeline/active/deals/${dealId}`);
        } else {
          this.setState({isEditing: false});
        }
      }
    });    
  };

  cleanDataForSave = (values) => {
    this.cleanCurrency(values, "capExReserves");
    this.cleanCurrency(values, "repair");
    this.cleanCurrency(values, "replacement");
    this.cleanCurrency(values, "tilcReserves");
    this.cleanCurrency(values, "quoteAggregateInterestDefinedAmt");
    values.loanProviders.forEach(x => this.cleanCurrency(x,'lenderAllocation'));


    this.cleanDSCR(values, "dscrAsIs");
    this.cleanDSCR(values, "dscrStabilized");
    this.cleanPercentage(values, "debtYieldAsIs");
    this.cleanPercentage(values, "debtYieldStabilized");
    this.cleanPercentage(values, "ltc");
    this.cleanPercentage(values, "ltvAsIs");
    this.cleanPercentage(values, "ltvStabilized");
    this.cleanPercentage(values, "occupancy");
    this.cleanPercentage(values, "originationFee");
    this.cleanPercentage(values, "extensionFees");
    this.cleanPercentage(values, "brokerFee");
    this.cleanPercentage(values, "exitFee");
    this.cleanPercentage(values, "otherFee");  
  }

  cleanCurrency = (values, field) => {
    if (typeof values[field] === 'string') 
      values[field] = Number(values[field].replace(/[^0-9\.-]+/g, ''));
  }

  cleanDSCR = (values, field) => {
    if (typeof values[field] === 'string') 
      values[field] = Number(values[field].replace(/[^0-9\.-]+/g, ''));
    
    if(!values[field] || values[field] === 0) 
      values[field] = null;
  }

  cleanPercentage = (values, field) => {
    if (typeof values[field] === 'string')
      values[field] = Number(values[field].replace(/[^0-9\.-]+/g, ''));
    if (!values[field] || values[field] === 0)
      values[field] = null;
    else
      values[field] = values[field] / 100;
  }

  save = (shouldClearLoan, callback) => {
    const data = { loan: { ...this.state.loan } };
    if (this.state.selectedLoanStatusId === loanStatuses.PASSED_QUOTE)
      data.loan = { ...data.loan, ...this.state.passReason };

    this.cleanDataForSave(data.loan);

    data.loan.dealId = this.props.dealId;
    data.shouldClearLoan = shouldClearLoan;
    data.callback = callback;
    this.props.addLoan(data);
    this.setState({isEditing: false, refreshLoanStatuses: true});
  };

  doesPassMultipleLenderValidation = () => {
    const LENDER_PASSED = '41eb3b82-4689-11e9-82f6-0242ac120002';
    const REJECTED = '398abe00-4689-11e9-82f6-0242ac120002';
    const { loan } = this.state;
    const { loanProviders } = loan;
    let allocationSumCheck = false;
    let leadCheck = false;
    let nonNullCheck = true;
    let shouldIgnoreAmount = (loan.loanStatusId == LENDER_PASSED || loan.statusId == REJECTED);

    loanProviders.forEach(
      provider => {
        if(provider.lenderAllocation===null){ //explicitly check null because 0 is a valid option
          provider.lenderAllocation=0;
        }
      }
    );
    if (!loan || !loanProviders) return true;

    // if just one lender, pass validation (nothing to validate)
    if (loanProviders.length === 1) {
      loanProviders[0].isLead=true;
      return {result:true};
    }
    
    if (!loan.amount && !shouldIgnoreAmount){
      return false;
    } 

    if (loanProviders.length > 1) {
      if(!shouldIgnoreAmount){
      const amount = isNaN(loan.amount) ? Number(loan.amount.replace(/[^0-9.-]+/g, "")) : loan.amount;
      // sum all lender allocation fields
      const lenderAllocationSum = loanProviders.reduce((accumulator, obj) => {
        const lenderAllocation = isNaN(obj.lenderAllocation) ? Number(obj.lenderAllocation.replace(/[^0-9.-]+/g, "")) : obj.lenderAllocation;
        return accumulator + Number(lenderAllocation)}, 0
      );
      if (lenderAllocationSum === Number(amount)) {
        allocationSumCheck = true;
      }
    }else{
      allocationSumCheck = true;
    }

      if (loanProviders.some( obj => obj.isLead === true)) {
        leadCheck = true;
      }

      loanProviders.forEach(lender=>{if(!lender.companyId)nonNullCheck=false});
    }
    return {result: (allocationSumCheck && leadCheck && nonNullCheck) , details:{leadCheck,allocationSumCheck,nonNullCheck}};
  }

  saveReturn = () => {
    const lenderValidation = this.doesPassMultipleLenderValidation();
    if (lenderValidation.result) {
      this.save(true, () => this.cancelEdit(true));
    } else {
      this.openLenderValidationModal(lenderValidation);
    }
  };

  saveStay = () => {
    const lenderValidation = this.doesPassMultipleLenderValidation();
    if (lenderValidation.result) {
      if (this.state.isNewLoan) {
        this.createQuote();
      } else {
        this.save(true);
      }
    } else {
      this.openLenderValidationModal(lenderValidation);
    }
  };

  createQuote = () => {
    this.save(false, () => {
      const savedLoanId = get(this.props.savedLoan, 'id');
      this.props.history.replace(`/loan/${this.props.dealId}/${savedLoanId}`);
        window.location.reload();
    })
  }

  editLoan = () => {        
    this.setState({isEditing: true});    
  };

  getBreadcrumb(loan) {
    const { dealNames, dealId, loanId } = this.props;
    const dealName = dealNames[dealId] ? dealNames[dealId].name : null;
    let lenderName = "New";
    if(loan.loanProviders){
      loan.loanProviders.forEach(provider => {
        if(provider.isLead && provider.company){
          lenderName = provider.company.name;
        }
      })
    }

    return (
      <Fragment>
        <BreadCrumbLink to={"/pipeline"}> {"Pipeline"} / </BreadCrumbLink>
        <BreadCrumbLink to={`/pipeline/active/deals/${dealId}`}>{dealName || "Deal"} / </BreadCrumbLink>
        <LastLink>{lenderName || "New"}</LastLink>
      </Fragment>
    );
  }

  openLenderValidationModal = (lenderValidation) => {
    this.setState({isValidationModalOpen: true})
    this.setState({lenderValidation})
  }
  closeValidationModal = () => {
    this.setState({isValidationModalOpen: false});
  }

  createDuplicate = () => {
    this.props.updateLoanStatusById({
      loanId: this.state.loan.id,
      loanStatusId: loanStatuses.QUOTE,
      callback: ()=>{},
      });
  }

  render() {
    const {
      loan,
      isNewLoan,
      isInitialized,
      selectedLoanStatusId,
      isAttachmentsOpen,
      activeSectionId,
      isEditing,
      isNotesOpen,
      styles,
      isValidationModalOpen,
      guestPermissions
    } = this.state;
    const { theme, savedLoan, authentication } = this.props;    
    if(savedLoan && savedLoan == 401) {
      this.props.clearEditLoan();
      this.props.history.push('/AccessDenied');
    }

    return (
      <Fragment>
        <QuoteDuplicationConfirmationDialog 
            modalOpen={this.state.isCloneDialogOpen}
            handleNo={this.closeCloneDialog}
            handleYes={()=>{this.props.history.push(`/loan/${this.props.match.params.dealId}/${this.props.clone.id}`)}}/>
        <Fragment>
          <LoanAttachments
            loanId={loan.id}
            isOpen={isAttachmentsOpen}
            openAttachments={this.openAttachments}
            closeAttachments={this.closeAttachments}
          />
          <LoanNotes
            loanId={loan.id}
            isOpen={isNotesOpen}
            openNotes={this.openNotes}
            closeNotes={this.closeNotes}
          />
        </Fragment>
        <Grid
          container
          alignItems="flex-start"
          justify="flex-start"
          direction="row"
          className={this.props.classes.marginalize}>
          {!authentication.isGuest && (<Grid item xs={12}>
            {this.getBreadcrumb(loan)}
          </Grid>)}
          <Grid item xs={12}>
            <LoanHeader
              editLoan={this.editLoan}
              onDuplicate={()=>{
                if(!this.state.duplicateReady){
                  return;
                }
                this.setState({duplicateReady:false});
                this.createDuplicate();}
              }
              saveLoan={this.saveStay}
              saveReturn={this.saveReturn}
              cancel={this.cancel}
              openNotes={this.openNotes}
              openAttachments={this.openAttachments}
              isEditing={isEditing}
              isNewLoan={isNewLoan}
              guestPermissions={guestPermissions}
              authentication={authentication}
            />
          </Grid>
          <Grid item xs={2}>
            <LoanNavigation
              isInitialized={
                isInitialized &&
                selectedLoanStatusId !== loanStatuses.PASSED_QUOTE
              }
              activeSectionId={activeSectionId} 
              selectSection={this.selectSection}/>
          </Grid>

          <Grid item xs={10} className={this.props.classes.container}>
            <Styles theme={theme}>
              <FormSection className="form-section" ref={this.formRef} onScroll={this.detectScroll}>
                <LoanTerms
                  isNewLoan={isNewLoan}
                  isEditing={isEditing}
                  isInitialized={isInitialized}
                  selectedLoanStatusId={selectedLoanStatusId}
                  handleChange={this.handleChange}
                  handleTextChange={this.handleTextChange}
                  handleLoanLenderChange={this.handleLoanLenderChange}
                  handleBooleanChange={this.handleBooleanChange}
                  loan={loan}
                  openLenderValidationModal={this.openLenderValidationModal}
                  loanStatuses={this.state.loanStatuses}
                  guestPermissions={guestPermissions}
                />
              
                {selectedLoanStatusId === loanStatuses.PASSED_QUOTE && isInitialized && (
                  <LenderPassed
                    isNewLoan={isNewLoan}
                    isEditing={isEditing}
                    isInitialized={isInitialized}
                    handleChange={this.handlePassReasonChange}
                    handleTextChange={this.handleTextChange}
                    handleBooleanChange={this.handleBooleanChange}
                    loan={loan}
                  />
                )}
                {selectedLoanStatusId !== loanStatuses.PASSED_QUOTE && (
                  <Recourse
                    isNewLoan={isNewLoan}
                    isEditing={isEditing}
                    isInitialized={isInitialized}
                    handleChange={this.handleChange}
                    handleTextChange={this.handleTextChange}
                    handleBooleanChange={this.handleBooleanChange}
                    loan={loan}
                  />
                )}
                {selectedLoanStatusId !== loanStatuses.PASSED_QUOTE && (
                  <Fees
                    isNewLoan={isNewLoan}
                    isEditing={isEditing}
                    isInitialized={isInitialized}
                    handleChange={this.handleChange}
                    handleTextChange={this.handleTextChange}
                    handleBooleanChange={this.handleBooleanChange}
                    loan={loan}
                  />
                )}
                {selectedLoanStatusId !== loanStatuses.PASSED_QUOTE && (
                  <Reserves
                    isNewLoan={isNewLoan}
                    isEditing={isEditing}
                    isInitialized={isInitialized}
                    handleChange={this.handleChange}
                    handleTextChange={this.handleTextChange}
                    handleBooleanChange={this.handleBooleanChange}
                    loan={loan}
                  />
                )}
                {selectedLoanStatusId !== loanStatuses.PASSED_QUOTE && (
                  <Hedge
                    isNewLoan={isNewLoan}
                    isEditing={isEditing}
                    isInitialized={isInitialized}
                    handleChange={this.handleChange}
                    handleTextChange={this.handleTextChange}
                    handleBooleanChange={this.handleBooleanChange}
                    loan={loan}
                  />
                )}
                {selectedLoanStatusId !== loanStatuses.PASSED_QUOTE && (
                  <Covenants
                    isNewLoan={isNewLoan}
                    isEditing={isEditing}
                    isInitialized={isInitialized}
                    handleChange={this.handleChange}
                    handleTextChange={this.handleTextChange}
                    handleBooleanChange={this.handleBooleanChange}
                    loan={loan}
                  />
                )}
                {selectedLoanStatusId !== loanStatuses.PASSED_QUOTE && (
                  <Other
                    isNewLoan={isNewLoan}
                    isEditing={isEditing}
                    isInitialized={isInitialized}
                    handleChange={this.handleChange}        
                    handleTextChange={this.handleTextChange}            
                    loan={loan}
                  />
                )}
              </FormSection>
            </Styles>
          </Grid>
        </Grid>
      {this.state.lenderValidation && this.state.lenderValidation.details &&
        <SimpleInfoDialog 
          title="Lender Error"
          message="One of the following errors was encountered when attempting to save the lender information"
          secondaryContent="Please fix these issues in order to save successfully."
          bulletPoints={[
           !this.state.lenderValidation.details.allocationSumCheck ? "Lender Allocations do not add up to equal the Loan Amount" : null,
           !this.state.lenderValidation.details.leadCheck ? "No Lead Lender was selected" : null,
           !this.state.lenderValidation.details.nonNullCheck ? "Lender Information not fully filled out" : null,
          ]}
          modalOpen={isValidationModalOpen}
          handleClose={this.closeValidationModal}
          handleAccept={this.closeValidationModal}
        />}

      </Fragment>
    );
  }
}

const mapStateToProps = (
  state,
  {
    match: {
      params: { isEditing, dealId, loanId }
    }
  }
) => {
  const { loading, loan, deal, enumeratedTypes,authentication, guest } = state;
  return {    
    loading,
    isEditingParam: isEditing === "edit" || !loanId,
    savedLoan: loan.editLoan && loan.editLoan.data ? loan.editLoan.data : null,
    dealId,
    loanId,
    clone : loan.lastCreatedClone,
    dealNames: deal.dealNames,
    enumeratedTypes: enumeratedTypes.enumeratedTypes,
    authentication,
    dealguests: guest.dealguests ? guest.dealguests[dealId] : [],
    guestPermission: guest.guestPermission ? guest.guestPermission : null,
  };
};

export default compose(
  connect(
    mapStateToProps,
    { addLoan, getLoanById, clearLoan,clearLoanCount, getDealName, getLenders, clearEditLoan, getloanStatuses, updateLoanStatusById,
      getGuestsByDealId }
  ),
  withStyles(styles),
  withTheme()
)(NewLoan);


